import React, { Component } from "react";

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import "./App.css";

import Login from "./screens/Login/login";

import Register from "./screens/Login/register";
import ForgotPassword from "./screens/Login/forgotPassword";

// import Evendts from "./screens/ShowEvents";
import Dashboard from "./screens/adminDashboard";
import Events from "./screens/Events";
import Teams from "./screens/TeamsScreen";

import PersistentDrawerLeft from "./components/Drawer";

import TopBar from "./components/TopBar";
import history from "./history";
import dataGenerate from "./components/dataGenerate";
import eventDataGenerate from "./components/eventDataGenerate";
import teamDataGenerate from "./components/teamDataGenerate";
// import AssetsNavigator from "./components/Navigation/navigatorAssets";
import UserAdmin from "./components/Navigation/navigatorUserAdmin";
import Assets from "./components/Navigation/navigatorAssets";
import CardComponent from "./components/CardComponent";
import EventScreen from "./screens/EventsScreen";
import TeamsScreen from "./screens/TeamsScreen";
import EditPage from "./screens/EditPage";
import EditTeamPage from "./screens/EditTeamPage";
import EventsPage from "./screens/EventsPage";
import AssetsPage from "./screens/AssetsPage";
import Comp from "./components/Navigation/navigatorCompanies";
import Signup from "./screens/Login/reg";
import ShowsPage from "./screens/ShowsPage";
import ManageAdmin from "./screens/ManageAdmin";
import CardCompShows from "./components/Navigation/CardComponentShows";
import ShowsNavigator from "./components/Navigation/navigatorShows";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs.jsx";
class App extends Component {
  render() {
    let routes;

    if (sessionStorage.getItem("Authenticated")) {
      routes = (
        <Switch>
          <Route path="/AddAccount" component={Register}></Route>
          <Route path="/dashboard" component={Dashboard}></Route>
          <Route path="/forgotPassword" component={ForgotPassword}></Route>

          <Route path="/events" component={Events}></Route>

          <Route path="/eventsPage" component={EventsPage}></Route>

          <Route path="/drawer" component={PersistentDrawerLeft}></Route>

          <Route path="/dataGenerate" component={dataGenerate}></Route>
          <Route
            path="/eventDataGenerate"
            component={eventDataGenerate}
          ></Route>
          <Route path="/teamDataGenerate" component={teamDataGenerate}></Route>

          <Route path="/topBar" component={TopBar}></Route>

          <Route path="/assets" component={Assets}></Route>

          <Route path="/user" component={UserAdmin}></Route>

          <Route path="/comp" component={Comp}></Route>

          <Route path="/card" component={CardComponent}></Route>

          <Route path="/editPage" component={EditPage}></Route>

          <Route path="/editTeamPage" component={EditTeamPage}></Route>

          <Route path="/AssetsPage" component={AssetsPage}></Route>

          <Route path="/reg" component={Signup}></Route>

          <Route path="/ShowsPage" component={ShowsPage}></Route>
          <Route path="/ManageAdmin" component={ManageAdmin}></Route>

          <Route path="/CardShows" component={CardCompShows}></Route>

          <Route path="/eventScreen" component={EventScreen}></Route>
          <Route path="/teamsScreen" component={TeamsScreen}></Route>

          <Route path="/navS" component={ShowsNavigator}></Route>
        </Switch>
      );
    } else {
      routes = (
        <Switch>
          <Route path="/" exact component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/privacy-policy" component={PrivacyPolicy}></Route>
          <Route path="/contact-us" component={ContactUs}></Route>
        </Switch>
      );
    }

    return (
      <div>
        <Router>{routes}</Router>
      </div>
    );
  }
}
export default App;
